import { render, staticRenderFns } from "./ks_count.vue?vue&type=template&id=dba9aee2&scoped=true"
import script from "./ks_count.vue?vue&type=script&lang=js"
export * from "./ks_count.vue?vue&type=script&lang=js"
import style0 from "./ks_count.vue?vue&type=style&index=0&id=dba9aee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba9aee2",
  null
  
)

export default component.exports